import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { finalize } from 'rxjs/operators';

import { ContactDataService } from 'src/app/services/gp/contact-data.service';
import { AlertDialogParams } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { DialogService } from 'src/app/services/dialog.service';
import { ContactSubscriptionRequest } from './ContactSubscriptionRequest.model';


@Component({
  selector: 'terra-contact-unsubscribe',
  templateUrl: './contact-unsubscribe.component.html',
  styleUrls: ['./contact-unsubscribe.component.scss']
})
export class ContactUnsubscribeComponent extends OnDestroyMixin implements OnInit {

  isLoading = true;

  // Parameters
  uniqueIdentifier = '';
  contactId = 0;

  agentCompanyName = '';
  unsubscribeFromMarketingEmails = false;

  unsubscribeSuccessful = false;
  subscribeSuccessful = false;

  get actionName() {

    if (this.unsubscribeFromMarketingEmails) {
      return 'Subscribe';
    }
    return 'Unsubscribe';
  }


  constructor(private titleService: Title,
              private router: Router,
              private route: ActivatedRoute,
              private contactDataService: ContactDataService,
              private dialogService: DialogService) {
                super();
              }


  ngOnInit() {
    this.titleService.setTitle('Unsubscribe' + TerraUtils.consts.LpPageTitleSuffix);
    this.getQueryParameters();
    this.getContactSubscription();
  }

  displayError(statusCode: number) {
    const dialogParams = new AlertDialogParams();

    dialogParams.title = `An error has occurred`;
    dialogParams.description = `An error has occurred, please try again or contact support`;
    dialogParams.actionLabel = `OK`;

    switch (statusCode) {
      case 409:
        dialogParams.description = 'An error has occurred, please try again or contact support';
        break;
    }
    this.dialogService
      .alertDialog(dialogParams)
      .afterClosed()
      .subscribe(() => { });
  }

  getQueryParameters() {
    this.route.params.subscribe(params => {
      this.contactId = +params.contactId;
      this.uniqueIdentifier = params.uniqueIdentifier;
    });
  }

  getContactSubscription() {
    if (this.contactId > 0 && this.uniqueIdentifier) {
      this.isLoading = true;

      this.contactDataService.GetContactSubscriptionState(this.contactId, this.uniqueIdentifier)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
          untilComponentDestroyed(this)
        )
        .subscribe(
          (contactSubscription: ContactSubscriptionRequest) => {

            this.agentCompanyName = contactSubscription.agentCompanyName;
            this.unsubscribeFromMarketingEmails = contactSubscription.unsubscribeFromMarketingEmails;
          },
          error => {
            this.displayError(error.status);
          }
        );
      }

  }

  unsubscribe() {
    if (this.contactId > 0 && this.uniqueIdentifier) {
      this.isLoading = true;

      const contactSubscriptionRequest = new ContactSubscriptionRequest();
      contactSubscriptionRequest.unsubscribeFromMarketingEmails = !this.unsubscribeFromMarketingEmails;

      this.contactDataService.UpdateContactSubscription(this.contactId, this.uniqueIdentifier, contactSubscriptionRequest)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
          untilComponentDestroyed(this)
        )
        .subscribe(
          (contactSubscriptionResponse: ContactSubscriptionRequest) => {

            this.unsubscribeFromMarketingEmails = contactSubscriptionResponse.unsubscribeFromMarketingEmails;

            this.subscribeSuccessful = !contactSubscriptionResponse.unsubscribeFromMarketingEmails;
            this.unsubscribeSuccessful = contactSubscriptionResponse.unsubscribeFromMarketingEmails;

          },
          error => {
            this.displayError(error.status);
          }
        );
    }
  }
}
